import React from "react";
import HighchartsReact from "highcharts-react-official";

const Highcharts = window.Highcharts;

export default function TopDomainPie({ data }) {
  const chartDataDayBefore = data.map((data) => [Number(data.daybefore)]);
  const chartDataYesterday = data.map((data) => [Number(data.yesterday)]);
  const chartDataToday = data.map((data) => [Number(data.today)]);
  const chartDataX = data.map((data) => [data.value]);

  const chartOptions = {
    chart: {
      height: 310,
      type: "column",
      options3d: {
        enabled: true,
        alpha: 5,
        beta: 0,
        depth: 50,
      },
    },
    legend: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "Paid Campaigns",
      style: {
        fontWeight: "bold",
        fontSize: "14",
      },
    },
    subtitle: {
      text: null,
    },
    xAxis: {
      categories: chartDataX,
    },
    yAxis: {
      type: "logarithmic",
      title: {
        text: null,
      },
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: true,
        },
        enableMouseTracking: false,
      },
    },
    series: [
      {
        name: "Total Visitor Clicks for Day Before",
        data: chartDataDayBefore,
      },
      {
        name: "Total Visitor Clicks for Yesterday",
        data: chartDataYesterday,
      },
      {
        name: "Total Visitor Clicks for Today",
        data: chartDataToday,
      },
    ],
  };

  return (
    <div className="chart-holder">
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  );
}
